export const environment = {
  production: true,
  baseUrl: location.origin,
};
 